module.exports = __webpack_public_path__ + "img/rights-1@2x.71afc39b.png";